export const toFixedNumber = (value: number, precision = 0): number => {
  const valueString = value?.toFixed(precision);

  let valueFixed = 0;

  if (valueString) {
    try {
      valueFixed = parseFloat(valueString);
    } catch {
      valueFixed = 100;
    }
  }

  return valueFixed;
};
